import React from 'react';
import { motion } from 'framer-motion';
import { AgentMark } from './AgentMark';
import { ProcessingTag } from './ProcessingTag';
import { getAgent } from '../../utils/agents';
import { useMotionPreference } from '../../hooks/useMotionPreference';
import type { AgentTask } from '../../types/db';

/** One live agent thread: task, step progress, elapsed time, lokaal/cloud. */
export function AgentThread({
  task
}: {
  task: AgentTask;
}) {
  const a = getAgent(task.agent);
  const reduce = useMotionPreference();
  const progress = task.step / task.totalSteps;
  const moving = task.status === 'bezig' && !reduce;
  return <div className="flex items-start gap-3" data-id="element-1311" data-mp="2tqoxsk72vnul">
      <AgentMark agentId={task.agent} data-id="element-1312" data-mp="2oqu5qdbkgs7y" />
      <div className="min-w-0 flex-1" data-id="element-1313" data-mp="2orvhyl4bjkr9">
        <div className="flex items-baseline justify-between gap-3" data-id="element-1314" data-mp="2oor6d2oixmqk">
          <p className="truncate text-[14px] font-medium text-ink" data-id="element-1315" data-mp="2knxig9b307xo">{task.title}</p>
          <span className="shrink-0 text-[12px] tabular-nums text-ink-muted" data-id="element-1316" data-mp="2fpw1pv14okpd">
            stap {task.step}/{task.totalSteps}
          </span>
        </div>
        <p className="truncate text-[13px] text-ink-soft" data-id="element-1317" data-mp="r05fjd5i1wwj">{task.stepLabel}</p>
        <div className="relative mt-2 h-[2px] rounded-full" style={{
        backgroundColor: `${a.color}26`
      }} data-id="element-1318" data-mp="vtzxab1jo1sz">
          <div className="absolute inset-y-0 left-0 rounded-full" style={{
          width: `${progress * 100}%`,
          backgroundColor: a.color
        }} data-id="element-1319" data-mp="hz7aqsn8llcw" />
          {moving && <motion.span aria-hidden className="absolute top-1/2 h-1.5 w-1.5 -translate-y-1/2 rounded-full" style={{
          backgroundColor: a.color
        }} initial={{
          left: '0%',
          opacity: 0
        }} animate={{
          left: `${progress * 100}%`,
          opacity: [0, 1, 1, 0]
        }} transition={{
          duration: 2.4 / Math.max(0.1, task.pace),
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-1320" data-mp="19tj5f3ucvd5a" />}
        </div>
        <div className="mt-2 flex items-center gap-2 text-[12px] text-ink-muted" data-id="element-1321" data-mp="3qh3rekcfq6ce">
          <span className="tabular-nums" data-id="element-1322" data-mp="3qf0stbx7v4w2">{task.elapsed}</span>
          <ProcessingTag where={task.where} data-id="element-1323" data-mp="1vzu15dltospt" />
          {task.status === 'wacht' && <span className="text-amber" data-id="element-1324" data-mp="1r1abp380sysp">wacht op jou</span>}
        </div>
      </div>
    </div>;
}